module.exports = __webpack_public_path__ + "img/chinesecompany99.43703a95.png";